module.exports = __webpack_public_path__ + "static/media/left.0193ee61.svg";